export default "__VITE_ASSET__9EEJL_5J__"